import React, { useEffect, useMemo } from 'react';
import { Bar, CartesianGrid, LabelList, ResponsiveContainer, Tooltip, XAxis, YAxis, BarChart } from 'recharts';

const options = [
  { value: 'jobManagement', label: 'Área' },
  { value: 'jobTitle', label: 'Cargo' },
  { value: 'costCenter', label: 'Centro de Costos' },
  { value: 'branchOffice', label: 'Lugar de Prestación de Servicios' }
];

function groupBy(data, key) {
  let data2 = [];
  switch (key) {
    case 'jobManagement':
      data2 = data.groupByJobManagement;
      break;
    case 'jobTitle':
      data2 = data.groupByJobTitle;
      break;
    case 'costCenter':
      data2 = data.groupByCostCenter;
      break;
    case 'branchOffice':
      data2 = data.groupByBranchOffice;
      break;
    default:
      data2 = [];
      break;
  }

  return Object.entries(data2).map(([index, value]) => ({
    name: index.trim(),
    value
  }));
}

const DinamicGraph = ({
  title = {},
  onRequest = false,
  setMaxHeight = () => {},
  filter = 'jobManagement',
  setFilter = () => {}
}) => {
  const data = useMemo(() => groupBy(title, filter), [title, filter]);

  const barHeight = 40;
  const chartHeight = Math.max(160, data.length * barHeight);
  useEffect(() => {
    setMaxHeight(chartHeight);
  }, [chartHeight, filter, data.length, setMaxHeight]);

  return (
    <>
      {!onRequest && (
        <div style={{ width: '100%', margin: '0 auto', background: '#fff', borderRadius: 8 }}>
          <div style={{ marginBottom: 10, display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontWeight: 'bold' }}>Contratados Por :</span>
            <select
              value={filter}
              onChange={e => setFilter(e.target.value)}
              style={{ padding: 4, borderRadius: 4, border: '1px solid #ccc' }}
            >
              {options.map(opt => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
          <ResponsiveContainer width="100%" height={chartHeight}>
            <BarChart
              data={data}
              layout="vertical"
              margin={{ top: 20, right: 30, left: 120, bottom: 5 }} // Ajusta left si los nombres son largos
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis type="number" style={{ fontSize: 10 }} />
              <YAxis width={120} dataKey="name" type="category" style={{ fontSize: 10 }} />
              <Tooltip />
              <Bar dataKey="value" fill="#90caf9">
                <LabelList dataKey="value" position="right" style={{ fontSize: 10 }} />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </>
  );
};
export default DinamicGraph;
